import { ArrowDownIcon } from "@app/design-system/icons";
import { BaseMarker } from "../BaseMarker";
import styles from "./DropoffMarker.module.css";

export type DropoffMarkerProps = {
  size?: number;
  color?: string;
  /** Route sequence number — Ondemand orders only, per spec. Omit for every
   * other order kind to render a plain down arrow. */
  sequence?: number;
};

/** Drop-off location: BaseMarker + a downward-pointing arrow, with the
 * route's sequence number alongside it for Ondemand orders. */
export const DropoffMarker = ({ size, color = "var(--color-icon-dark)", sequence }: DropoffMarkerProps) => (
  <BaseMarker size={size} color={color}>
    <span className={styles.content} style={{ color }}>
      {sequence !== undefined ? <span className={styles.sequence}>{sequence}</span> : null}
      <ArrowDownIcon size={sequence !== undefined ? 11 : 14} color={color} />
    </span>
  </BaseMarker>
);
